import SaveToMateDrive from './SaveToMateDrive/SaveToMateDrive';
import DeleteFromMateDrive from './DeleteFromMateDrive/DeleteFromMateDrive';

import { types } from './types';


function Actions(action, variables, setOpenVariable, automId) {
    switch (action.actionName) {
        case types.SAVETOMATEDRIVE:
            return <SaveToMateDrive action={action} variables={variables} setOpenVariable={setOpenVariable}
                automId={automId} />;
        case types.DELETEFROMMATEDRIVE:
            return <DeleteFromMateDrive action={action} variables={variables} setOpenVariable={setOpenVariable}
                automId={automId} />;
        default:
            break;
    }
}

export default Actions;
